import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import PageTitle from '../controls/PageTitle'
import DeviceListView from './DeviceListView'
import * as DeviceActionCreators from '../../actions/device'
import * as UnitActionCreators from '../../actions/unit'
import * as TimeseriesActionCreators from '../../actions/timeseries'

class DeviceListPage extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    match: PropTypes.object.isRequired,
    /* mapped state */
    devices: PropTypes.object.isRequired,
    devicesByUnit: PropTypes.object.isRequired,
    timeseries: PropTypes.object.isRequired,
    /* mapped dispatch */
    unitActions: PropTypes.object.isRequired,
    deviceActions: PropTypes.object.isRequired,
    timeseriesActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      devices: state.devices,
      devicesByUnit: state.devicesByUnit,
      timeseries: state.timeseries,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      unitActions: bindActionCreators(UnitActionCreators, dispatch),
      deviceActions: bindActionCreators(DeviceActionCreators, dispatch),
      timeseriesActions: bindActionCreators(TimeseriesActionCreators, dispatch),
    }
  }

  componentDidMount() {
    this.update(this.unitId())
  }

  componentDidUpdate(prevProps) {
    this.update(this.props.match.params.unitId, prevProps.match.params.unitId)
  }

  update(id, prevId) {
    const { unitActions, timeseriesActions } = this.props
    if (id !== prevId) {
      unitActions.fetchUnit(id)
      unitActions.listUnitDevices(id)
      timeseriesActions.listUnitTimeseries(id)
    }
  }

  unitId() {
    return parseInt(this.props.match.params.unitId, 10)
  }

  render() {
    const {
      devices, devicesByUnit, timeseries, deviceActions, timeseriesActions,
    } = this.props
    const unitId = this.unitId()

    const deviceIds = devicesByUnit[unitId] || []
    const unitDevices = []
    deviceIds.forEach((id) => {
      if (devices[id]) {
        unitDevices.push(devices[id])
      }
    })

    return (
      <>
        <PageTitle title="Device List" />
        <DeviceListView
          devices={unitDevices}
          onUpdateDevice={deviceActions.updateDevice}
          onRemoveDevice={deviceActions.removeDevice}
          timeseries={timeseries}
          onAddUnitTimeseries={timeseriesActions.addUnitTimeseries}
          onSaveUnitTimeseries={timeseriesActions.saveUnitTimeseries}
        />
      </>
    )
  }
}

export default connect(
  DeviceListPage.mapStateToProps,
  DeviceListPage.mapDispatchToProps,
)(DeviceListPage)
